import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

export default new Vuex.Store({
    state:{
        userInfo: {},
        menus: [],
    },
    mutations:{
        setMenus(state, menus) {
            state.menus = menus;
        },
        setUserInfo(state, userInfo){
            state.userInfo = userInfo;
        },
        reset(state){
            state.userInfo = {};
        },
        resetMenus(state) {
            state.menus = [];
        },
    },
    getters:{
    },
    actions:{
        resetAction({ commit }){
            commit('reset')
        },
        resetMen({ commit }) {
            commit('resetMenus')
        }
    },
    modules:{
    },
    plugins: [createPersistedState()]
})